import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { Typography } from 'wanderu-components';
import { durationToHoursAndMinutes } from 'wanderu-utils';

import styles from './RoutesRow.scss';

const propTypes = {
    avgPrice: PropTypes.number.isRequired,
    avgTime: PropTypes.string.isRequired,
    dailyTrips: PropTypes.number.isRequired,
    destination: PropTypes.string.isRequired,
    i18nMoment: PropTypes.func.isRequired,
    i18nMoney: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
};

const RoutesRow = (props) => {
    const {
        avgPrice,
        avgTime,
        dailyTrips,
        destination,
        i18nMoment,
        i18nMoney,
        t,
        url,
    } = props;

    const averageTime = i18nMoment.duration(parseInt(avgTime, 10), 'minutes');
    const duration = durationToHoursAndMinutes(averageTime);
    const durationString = t(
        `baseApp:trip-duration_${duration.days > 0
            ? 'days'
            : 'hours'}`,
        duration,
    );
    const averagePrice = i18nMoney(avgPrice).format();

    return (
        <tr className={styles.tableRow}>
            <td>
                <A href={url}>{destination}</A>
            </td>
            <td>
                <Typography>
                    {dailyTrips}
                </Typography>
            </td>
            <td>
                <Typography>
                    {durationString}
                </Typography>
            </td>
            <td>
                <Typography>
                    {averagePrice}
                </Typography>
            </td>
        </tr>
    );
};

RoutesRow.propTypes = propTypes;

export default RoutesRow;
